import { WorkOrder as RltWorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import { useEffect } from "react";
import { useRltTreatmentShowQuery } from "@/services/backend/rlt/treatments/api/treatment-api";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { formatDate } from "@/shared/lib/utilities/date";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";
import { ConnectInvoiceExportDialog } from "@/services/backend/connect/components/connect-invoice-export";
import {
  useRltPricing,
  useRltSegmentPrices,
} from "@/services/backend/connect/components/string-builder-helpers-rlt";
import {
  useAttachmentsString,
  useServiceKindTitle,
  useWorkOrderReference,
} from "@/services/backend/connect/components/string-builder-helpers";

export function ConnectInvoiceExportDialogRlt({
  workOrder,
}: {
  workOrder: RltWorkOrder;
}) {
  return (
    <ConnectInvoiceExportDialog>
      <RltInvoiceExport workOrder={workOrder} />
    </ConnectInvoiceExportDialog>
  );
}

export function RltInvoiceExport({ workOrder }: { workOrder: RltWorkOrder }) {
  const [editor] = useLexicalComposerContext();
  const { data: treatment } = useRltTreatmentShowQuery({
    id: workOrder.treatmentId,
  });

  const title = useServiceKindTitle(GSMServiceKind.RLT);
  const workOrderReference = useWorkOrderReference(
    workOrder.id,
    GSMServiceKind.RLT,
  );
  const segmentPrices = useRltSegmentPrices(treatment);
  const pricing = useRltPricing(workOrder.pricingId);
  const attachments = useAttachmentsString();

  useEffect(() => {
    editor.update(() => {
      const root = $getRoot();
      root.clear();

      const paragraphNode = $createParagraphNode();

      paragraphNode.append($createTextNode(title));
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(workOrderReference));
      paragraphNode.append($createTextNode("\n"));
      paragraphNode.append(
        $createTextNode(
          `Leistungszeitpunkt: ${formatDate(workOrder.beginDate)}`,
        ),
      );
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(segmentPrices));
      paragraphNode.append($createTextNode("\n"));
      paragraphNode.append($createTextNode(pricing));
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(attachments));

      root.append(paragraphNode);
    });
  });

  return null;
}
